import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { Adal8Service } from 'adal-angular8';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { i18nModule } from './i18n.module';
import { IncidentModule } from './incident/incident.module';
import { InspectionModule } from './inspection/inspection.module';
import { MasterscreenService } from './masterscreen/services/masterscreen.service';
import { PermitToWorkModule } from './permit-to-work/permit-to-work.module';
import { PersonOnBoardModule } from './person-on-board/person-on-board.module';
import { RiskModule } from './risk/risk.module';
import { AuthGuard } from './shared/AuthGuard/auth.guard';
import { NotificationsComponent } from './shared/directives/notifications/notifications.component';
import { AuthenticationService } from './shared/services/authentication.service';
import { BaseService } from './shared/services/base.service';
import { CommonService } from './shared/services/common.service';
import { ConstantsService } from './shared/services/constants.service';
import { DataService } from './shared/services/data.service';
import { NotificationsService } from './shared/services/notification.service';
import { SharedModule } from './shared/shared.module';
import { TaskModule } from './task/task.module';
import { PermitToWorkService } from './permit-to-work/services/permittowork.service';
import { TrainingAndCompetencyModule } from './training-and-competency/training-and-competency.module';
import { DocumentLibraryModule } from './document-library/document-library.module';
import { PerformanceModule } from './performance-dashboard/performance.module';

// import { AgmCoreModule } from '@agm/core';


@NgModule({
  declarations: [
    AppComponent,
    NotificationsComponent
  ],
  imports: [
    BrowserModule,
    // AgmCoreModule.forRoot({
       
    //    apiKey: ConstantsService.URL.MAP_KEY
        
    //  }),
    //InMemoryWebApiModule.forRoot(TestData),
    AppRoutingModule,
    SharedModule,
    RiskModule,
    IncidentModule,
    BrowserAnimationsModule,
    TaskModule,
    InspectionModule,
    PersonOnBoardModule,
    HttpClientModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    i18nModule,
    PermitToWorkModule,
    TrainingAndCompetencyModule,
    DocumentLibraryModule,
    PerformanceModule
  ],
  providers: [
    AuthenticationService,
    PermitToWorkService,
    BaseService,
    DataService,
    ConstantsService,
    CommonService,
    MasterscreenService,
    Adal8Service,
    AuthGuard,
    NotificationsService
  ],
  exports: [i18nModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
